import {AddSchema} from "mobx-graphlink";
import {AutoEndType} from "../@EngineConfig.js";
import {Setting} from "./@Shared/Setting.js";
import {EffectPointer} from "../../@Shared/EffectPointer.js";
import {EffectSource_values_alerts, type EffectSource} from "../../../../Engine/LiveSession/Components/AlertsComp.js";

export class EngineConfig_Alerts {
	constructor(initialData: Partial<EngineConfig_Alerts>) { Object.assign(this, initialData); }

	events_addForAlertTypes: EffectSource[];

	lightEffectPointer = new EffectPointer();
	effectBaseApplyInterval: number; // in seconds

	// battery low
	batteryLow_threshold: number; // 0-1
	batteryLow_slowChargeDetection: boolean;
	batteryLow_lockLightsToBrightness: number; // 0-1 (if <0, feature is disabled)
}
AddSchema("EngineConfig_Alerts", {
	properties: {
		events_addForAlertTypes: {type: "array", items: {enum: EffectSource_values_alerts}},
		lightEffectPointer: {$ref: "EffectPointer"},
		effectBaseApplyInterval: {type: "number"},
		batteryLow_threshold: {type: "number"},
		batteryLow_slowChargeDetection: {type: "boolean"},
		batteryLow_lockLightsToBrightness: {type: "number"},
	},
});